export default {"src":"/_next/static/media/crosshatch-warning.cb2b0106.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};